/**
 * Keep the browser tab title on the server's configured app name.
 *
 * index.html can only carry the build-time name, so without this a deployment
 * that overrides `BOOND_APP_NAME` renames every surface *except* the tab — the
 * one piece of branding that stays visible when the app is in a background tab.
 */
import { useEffect } from "react";

export function useDocumentTitle(title: string): void {
  useEffect(() => {
    if (title && document.title !== title) document.title = title;
  }, [title]);
}
